export const WEATHER_REDUCER = 'WEATHER_REDUCER'



export const LIGHT_RAIN = 'light rain'
export const SKY_CLEAR = 'clear sky'